module.exports = __webpack_public_path__ + "static/img/ic_gy_d_d@2x.0c18efb5.png";